/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_No_Next_SectionInputs */

const en_playbar_no_next_section = /** @type {(inputs: Playbar_No_Next_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No next section`)
};

const es_playbar_no_next_section = /** @type {(inputs: Playbar_No_Next_SectionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay sección siguiente`)
};

/**
* | output |
* | --- |
* | "No next section" |
*
* @param {Playbar_No_Next_SectionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_no_next_section = /** @type {((inputs?: Playbar_No_Next_SectionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_No_Next_SectionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_no_next_section(inputs)
	return en_playbar_no_next_section(inputs)
});